<template>
  <!-- SVG -->
  <picture v-if="['de', 'el', 'gu', 'hu', 'kn', 'ml', 'or', 'ru', 'si', 'ta', 'te', 'trp', 'vi'].includes(locale)" class="img">
    <img :src="`/lotties/ribbon_${locale}.svg`" alt="">
  </picture>
  <!-- Lottie -->
  <ClientOnly v-else>
    <Vue3Lottie
      ref="lottie"
      :animation-link="`/lotties/ribbon_${
        [
          'bn',
          'cn',
          'cs',
          'en',
          'es',
          'fil',
          'fr',
          'hi',
          'id',
          'ja',
          'km',
          'ko',
          'mn',
          'ms',
          'my',
          'ne',
          'ny',
          'pt',
          'ro',
          'th',
          'zh',
        ].includes(locale)
          ? locale
          : 'en'
      }.json`"
      :speed="1"
      :loop="false"
      :auto-play="true"
    />
  </ClientOnly>
</template>

<script lang="ts" setup>
import { Vue3Lottie } from 'vue3-lottie'

const { locale } = useI18n()
</script>
